import humps from 'humps';
import request from '../../request';
import router from '../../routes';

let storedPromoter = {
  id: null,
  companyName: '',
  brandName: '',
  rnaatNumber: '',
  nipc: '',
  address1: '',
  address2: '',
  postalCode: '',
  city: '',
  websiteUrl: '',
  contactPersonFirstName: '',
  contactPersonLastName: '',
  contactPersonPhoneNumber: '',
  contactPersonEmail: '',
  paymentMethodId: null,
  acceptsMoney: undefined,
  acceptsDebitCard: null,
  acceptsCreditCard: null,
  acceptsOtherPayments: null,
  otherPaymentsDescription: '',
};

if (localStorage.getItem('promoter') !== null) {
  storedPromoter = JSON.parse(localStorage.getItem('promoter'));
}

const formData = {
  companyName: storedPromoter.companyName,
  brandName: storedPromoter.brandName,
  rnaatNumber: storedPromoter.rnaat_number,
  nipc: storedPromoter.nipc,
  address1: storedPromoter.address1,
  address2: storedPromoter.address2,
  postalCode: storedPromoter.postalCode,
  city: storedPromoter.city,
  websiteUrl: storedPromoter.websiteUrl,
  contactPersonFirstName: storedPromoter.contactPersonFirstName,
  contactPersonLastName: storedPromoter.contactPersonLastName,
  contactPersonPhoneNumber: storedPromoter.contactPersonPhoneNumber,
  contactPersonEmail: storedPromoter.contactPersonEmail,
  paymentMethodId: storedPromoter.paymentMethodId,
  acceptsMoney: storedPromoter.acceptsMoney,
  acceptsDebitCard: storedPromoter.acceptsDebitCard,
  acceptsCreditCard: storedPromoter.acceptsCreditCard,
  acceptsWhichCreditCards: storedPromoter.acceptsWhichCreditCard,
  acceptsOtherPayments: storedPromoter.acceptsOtherPayments,
  otherPaymentsDescription: storedPromoter.otherPaymentsDescription,
};

export default {
  namespaced: true,
  state: {
    formSaved: false,
    data: storedPromoter,
    formErrors: [],
    form: formData,
    formOptions: {
      paymentMethod: [
        {
          value: 1,
          label: 'Handle payments for me',
        },
        {
          value: 2,
          label: 'Only charge commissions',
        },
      ],
    },
  },
  mutations: {
    set(state, payload) {
      const serverPromoter = humps.camelizeKeys(payload);
      Object.keys(state.data).forEach((key) => {
        Object.assign(state.data, { [key]: serverPromoter[key] });
        Object.assign(state.form, { [key]: serverPromoter[key] });
      });
      localStorage.setItem('promoter', JSON.stringify(serverPromoter));
      setTimeout(() => {
        if (typeof window.Materialize !== 'undefined') {
          if (typeof window.Materialize.updateTextFields !== 'undefined') window.Materialize.updateTextFields();
        }
      }, 0);
    },
    setFormValue(state, payload) {
      Object.assign(state.form, { [payload.field]: payload.value });
    },
    setErrors(state, serverFormErrors) {
      const formErrors = humps.camelizeKeys(serverFormErrors);
      Object.assign(state, { formErrors });
    },
    setFormSaved(state, formSaved) {
      Object.assign(state, { formSaved });
    },
  },
  actions: {
    save(context, payload) {
      return new Promise((resolve, reject) => {
        const data = {
          username: context.rootState.user.data.username,
          company_name: context.state.form.companyName,
          brand_name: context.state.form.brandName,
          rnaat_number: context.state.form.rnaatNumber,
          nipc: String(context.state.form.nipc),
          address_1: context.state.form.address1,
          address_2: context.state.form.address2,
          postal_code: context.state.form.postalCode,
          city: context.state.form.city,
          website_url: context.state.form.websiteUrl,
          contact_person_first_name: context.state.form.contactPersonFirstName,
          contact_person_last_name: context.state.form.contactPersonLastName,
          contact_person_phone_number: String(context.state.form.contactPersonPhoneNumber),
          contact_person_email: context.state.form.contactPersonEmail,
          payment_method_id: context.state.form.paymentMethodId,
          legal_persons: humps.decamelizeKeys(context.rootState.legalPeople.form),
          country_id: 1,
        };
        if (context.state.form.paymentMethodId === 0) {
          data.payment_method_id = 1;
        }
        if (context.state.form.paymentMethodId === 2) {
          data.accepts_money = context.state.form.acceptsMoney;
          data.accepts_debit_card = context.state.form.acceptsDebitCard;
          data.accepts_credit_card = context.state.form.acceptsCreditCard;
          data.accepts_other_payments = context.state.form.acceptsOtherPayments;

          if (context.state.form.acceptsCreditCard) {
            data.accepts_which_credit_cards = context.state.form.acceptsWhichCreditCards;
          }
          if (context.state.form.acceptsOtherPayments) {
            data.other_payments_description = context.state.form.otherPaymentsDescription;
          }
        }

        if (typeof payload !== 'undefined') {
          if (payload.validateOnly) data.validateOnly = true;
        }

        request.make({
          type: 'PUT',
          url: `${process.env.API_URL}promoter`,
          data,
        }, (err, res) => {
          if (res.status === 422) {
            context.commit('setErrors', res.body.errors);
            context.commit('legalPeople/setErrors', res.body.errors, { root: true });
            if (typeof data.validateOnly === 'undefined') {
              context.commit('setShowAllValidationErrors', true, { root: true });
              context.dispatch('showSaveError', undefined, { root: true });
            }
            reject();
          } else if (res.status === 200 || res.status === 204) {
            context.commit('setErrors', {});
            context.commit('legalPeople/setErrors', {}, { root: true });
            if (typeof payload === 'undefined') {
              context.commit('setShowAllValidationErrors', false, { root: true });
              // context.commit('setFormSaved', true);
            }
            resolve();
          }
        });
      });
    },
    setFormSaved(context, value) {
      context.commit('setFormSaved', value);
    },
    get(context) {
      return new Promise((resolve) => {
        if (context.rootState.userDeprecated.data.type !== 'promoter') {
          router.push(`/${context.rootState.language}/login`);
        }
        request.make({
          type: 'GET',
          url: `${process.env.API_URL}promoter/${context.rootState.userDeprecated.data.username}`,
        }, (err, res) => {
          if (res !== 'undefined') {
            if (res.status === 200) {
              context.commit('set', res.body.data);
              context.dispatch('legalPeople/set', res.body.data.legalPersons.data, { root: true });
              resolve();
            }
          }
        });
      });
    },
    validate(context) {
      context.dispatch('save', { validateOnly: true }).catch(() => false);
    },
    setFormValue(context, payload) {
      context.commit('setFormValue', payload);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/promoter/promoter.js